
const digest = 'dcc7985852aa6c859f41a9cd0db940618451f3d4f3e49ef6ff9df660b6836bfe';
const classes = {"wrapper":"_wrapper_wu30g_1","loadingWrapper":"_loadingWrapper_wu30g_10"};
const css = `._wrapper_wu30g_1 {
  display: flex;
  flex-direction: row;
  font-family: Rubik, "sans-serif";
  flex-grow: 1;
  height: 100%;
  border: 1px solid #eaedf3;
  background-color: #ffffff;
}
._wrapper_wu30g_1 ._loadingWrapper_wu30g_10 {
  height: 100%;
  padding: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  